import pluralize from 'pluralize'
import { DateTime } from 'luxon'
import _ from 'lodash'

export default {
  clearData (data) {
    for (const key in data) {
      if (key === 'id') delete data[key]
      else if (data[key] instanceof File) delete data[key]
      else if (data[key] !== null && typeof (data[key]) === 'object') {
        this.clearData(data[key])
      } else {
        data[key] = null
      }
    }
  },
  copyData (from, to) {
    this.clearData(to)
    if (to !== null && typeof to === 'object') {
      for (const key in to) {
        if (to[key] !== null && typeof (to[key]) === 'object' && from[key] !== null) {
          this.copyData(from[key], to[key])
        } else if (from[key] !== null) {
          to[key] = from[key]
        }
      }
    } else {
      to = from
    }
  },
  find (objects, match, value, key) {
    const obj = _.find(objects, function (o) { return o[match] === value })
    if (obj && obj[key]) return obj[key]
    else if (obj) return obj
    return null
  },
  firstToLower (string) {
    return string.charAt(0).toLowerCase() + string.slice(1)
  },
  camelToKebab (string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
  },
  camelToString (string) {
    return string.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase()
  },
  kebabToCamel (string) {
    return string.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase()
    })
  },
  camelToSpace (string) {
    return string.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase()
  },
  camelToSnake (string) {
    return string.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
  },
  snakeToCamel (string) {
    return string.replace(/(_\w)/g, function (m) {
      return m[1].toUpperCase()
    })
  },
  spaceToPlus (string) {
    return string.replace(/\s/g, '+')
  },
  parseURL (string) {
    return new URL(string)
  },
  randStr (length) {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  },
  key () {
    return this.randStr(8)
  },
  pluralize,
  singular (string) {
    return pluralize.singular(string)
  },
  base64ToFile (base64, filename) {
    const arr = base64.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }

    return new File([u8arr], filename, { type: mime })
  },
  secondsToTime (seconds) {
    const date = new Date(0)
    date.setSeconds(seconds)
    return date.toISOString().substr(11, 8)
  },
  secondsToHumanTime (seconds) {
    const date = new Date(0)
    date.setSeconds(seconds)
    let hours = date.toISOString().substr(11, 2)
    if (parseInt(hours) > 0) hours = hours + ' Hours'
    else hours = ''
    let minutes = date.toISOString().substr(14, 2)
    if (parseInt(minutes) > 0) minutes = minutes + ' Minutes'
    else minutes = ''
    return hours + ' ' + minutes
  },
  dtFull (iso) {
    return DateTime.fromISO(iso).toFormat('LLL d, yyyy h:mm a')
  },
  dt12Time (iso) {
    return DateTime.fromISO(iso).toFormat('h:mm a')
  },
  joinObjects (separator, label, array) {
    const labels = []
    if (typeof array === 'object') {
      array.forEach(function (a) {
        labels.push(a[label])
      })
      return labels.join(separator)
    } else {
      return ''
    }
  },
  nl2br (str, isXHTML) {
    if (typeof str === 'undefined' || str === null) {
      return ''
    }
    const breakTag = (isXHTML || typeof isXHTML === 'undefined') ? '<br />' : '<br>'
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
  }
}
